import React from 'react';
import { Box, Typography, LinearProgress } from '@material-ui/core';
import { getStatusIcon } from '../../utils/status.tsx';
import { StatusType } from '../../types/deployment';
import { useDeploymentStyles } from '../../styles/deployment';

interface MetricsSectionProps {
  statusType: StatusType;
  statusText: string;
  changesCount: number;
  deploymentProgress?: number;
  lastDeploy: string;
}

export const MetricsSection = ({
  statusType,
  statusText,
  changesCount,
  deploymentProgress = 0,
  lastDeploy,
}: MetricsSectionProps) => {
  const classes = useDeploymentStyles();

  return (
    <Box className={classes.metricsSection}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Box display="flex" alignItems="center">
          {getStatusIcon(statusType)}
          <Typography
            variant="body1"
            style={{ marginLeft: 8, fontWeight: 500 }}
          >
            {statusText}
          </Typography>
        </Box>
        <Typography variant="caption" color="textSecondary">
          {changesCount} changes
        </Typography>
      </Box>

      {deploymentProgress > 0 && (
        <Box mb={1}>
          <LinearProgress
            variant="determinate"
            value={deploymentProgress}
            className={classes.progressBar}
          />
          <Typography variant="caption" color="textSecondary">
            Deployment: {deploymentProgress}%
          </Typography>
        </Box>
      )}

      <Typography variant="body2" color="textSecondary">
        <strong>Last Deploy:</strong> {lastDeploy}
      </Typography>
    </Box>
  );
};
